<template>
  <v-container class="fill-height">
    <v-navigation-drawer
      v-model="drawer"
      app
    >
      <v-list>
        <v-list-item
          link
          @click="goTo('/admin/question')"
        >
          <v-list-item-action>
            <v-icon>help</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Question</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          @click="goTo('/admin')"
        >
          <v-list-item-action>
            <v-icon>people</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Client</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      color="blue"
      dark
      dense
    >
      <v-app-bar-nav-icon @click="drawer = !drawer" />
      <v-toolbar-title>Le pourvoir des cures</v-toolbar-title>
    </v-app-bar>

    <v-content class="fill-height">
      <slot />
    </v-content>
  </v-container>
</template>

<script>
export default {
  name: 'Layout',
  data: () => ({
    drawer: false,
  }),
  methods: {
    goTo(page) {
      this.$router.push(page);
      this.drawer = false;
    },
  },
};
</script>

<style>
@media (min-width: 1264px) {
  .container {
    max-width: 1920px !important;
  }
}
@media (min-width: 960px) {
  .container {
    max-width: 1920px !important;
  }
}
</style>
